module.exports = __webpack_public_path__ + "img/confetti.c70aef9b.png";